export enum FilterSortDataType {
  TEXT = 'text',
  NUMBER = 'number',
  DATE = 'date',
  MONTH_YEAR_START = 'month-year-start',
  MONTH_YEAR_END = 'month-year-end',
  RELEVANCE = 'relevance',
  BOOLEAN = 'boolean',
  ENUM = 'enum',
}
